import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { getDefaultDates } from '../utils/weekDates';

const GetDeliveryAddresses = () => {
  const defaults = getDefaultDates();
  const [menuTypes, setMenuTypes] = useState([]);
  const [selectedMenuType, setSelectedMenuType] = useState('');
  const [pendingStart, setPendingStart] = useState(defaults.start);
  const [pendingEnd, setPendingEnd] = useState(defaults.end);
  const [addresses, setAddresses] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  const authHeaders = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchAddresses = async (start, end, menuType) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({ startDate: start, endDate: end });
      if (menuType) params.set('menuType', menuType);
      const res = await fetch(
        `https://api.reshipesbakery.com/reshipes/getThisWeeksAddresses?${params}`,
        { headers: authHeaders }
      );
      if (!res.ok) throw new Error('Failed to load addresses');
      setAddresses(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch('https://api.reshipesbakery.com/reshipes/getMenuTypes', { headers: authHeaders })
      .then(r => r.ok ? r.json() : []).then(setMenuTypes).catch(() => {});
    fetchAddresses(defaults.start, defaults.end, '');
  }, [token]);

  const handleApply = () => fetchAddresses(pendingStart, pendingEnd, selectedMenuType);

  return (
    <div className="container mt-5">
      <h1>Delivery Addresses</h1>

      <div className="mt-3 d-flex flex-wrap gap-3 align-items-end">
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>Menu</label>
          <select
            className="form-select form-select-sm"
            value={selectedMenuType}
            onChange={e => setSelectedMenuType(e.target.value)}
            style={{ minWidth: 160 }}
          >
            <option value="">All Menus</option>
            {menuTypes.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>From</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingStart} onChange={e => setPendingStart(e.target.value)} />
        </div>
        <div>
          <label className="form-label mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>To</label>
          <input type="date" className="form-control form-control-sm"
            value={pendingEnd} onChange={e => setPendingEnd(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-sm" onClick={handleApply}>Apply</button>
      </div>

      {loading && <div className="mt-4">Loading…</div>}
      {error && <div className="mt-4 text-danger">{error}</div>}

      {!loading && addresses && addresses.length === 0 && (
        <p className="mt-4">No delivery addresses found for this period.</p>
      )}

      {!loading && addresses && addresses.length > 0 && (
        <div className="mt-4">
          {addresses.map((address, index) => (
            <div key={index} className="mt-4">
              <h3>{address.customerName}</h3>
              <p>Address: {address.streetAddress}{address.aptNumber ? `, Apt ${address.aptNumber}` : ''}</p>
              <p>City: {address.city}</p>
              <p>State: {address.state}</p>
              <p>Zip Code: {address.zipCode}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GetDeliveryAddresses;
